<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon">
      <mat-icon>history</mat-icon>
    </div>
    <div class="ctd-header-text">
      <h2 class="cf-dlg-title">{{ name || 'Histórico del contacto' }}</h2>
      <p class="cf-dlg-subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="loading" message="Cargando histórico…"></app-loading-state>

  <ng-container *ngIf="!loading && loadError">
    <div class="cf-dlg-body">
      <div class="ctd-empty ctd-empty--error">
        <mat-icon>warning</mat-icon>
        <span class="ctd-empty__title">No se pudo cargar el histórico</span>
        <span class="ctd-empty__text">{{ errorMessage }}</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="getData()">
        <mat-icon>history</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="!loading && !loadError && loaded">
    <div class="cf-dlg-body">
      <div class="ctd-toolbar">
        <div class="ctd-tabs" role="tablist">
          <button type="button" class="ctd-tab" role="tab" [class.ctd-tab--active]="client"
                  [attr.aria-selected]="client" (click)="changeClient()">
            <mat-icon>person</mat-icon>
            Cliente
            <span class="ctd-tab__count">{{ clientCount }}</span>
          </button>
          <button type="button" class="ctd-tab" role="tab" [class.ctd-tab--active]="provider"
                  [attr.aria-selected]="provider" (click)="changeProvider()">
            <mat-icon>business</mat-icon>
            Proveedor
            <span class="ctd-tab__count">{{ providerCount }}</span>
          </button>
        </div>

        <div class="ctd-search">
          <mat-icon>search</mat-icon>
          <input type="text" [ngModel]="search" (ngModelChange)="onSearchChange($event)"
                 placeholder="Buscar número, nombre, fecha o importe…" autocomplete="off" aria-label="Buscar">
          <button type="button" class="ctd-search__clear" *ngIf="search" (click)="onSearchChange('')" aria-label="Limpiar búsqueda">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <button mat-stroked-button class="cf-btn ctd-excel" (click)="getExcel()">
          <mat-icon>file_download</mat-icon> Excel
        </button>
      </div>

      <div class="ctd-totals">
        <div class="ctd-total">
          <span class="ctd-total__label">{{ client ? 'Cobrado' : 'Pagado' }}</span>
          <strong class="ctd-total__value ctd-total__value--paid">{{ (client ? paidedClient : paidedProvider) | number:'1.2-2' }} €</strong>
        </div>
        <div class="ctd-total">
          <span class="ctd-total__label">{{ client ? 'No cobrado' : 'No pagado' }}</span>
          <strong class="ctd-total__value ctd-total__value--pending">{{ (client ? notPaidedClient : notPaidedProvider) | number:'1.2-2' }} €</strong>
        </div>
        <div class="ctd-total">
          <span class="ctd-total__label">Años anteriores</span>
          <strong class="ctd-total__value ctd-total__value--previous">{{ (client ? noPaidedPreviousYearsClient : noPaidedPreviousYearsProvider) | number:'1.2-2' }} €</strong>
        </div>
        <div class="ctd-total ctd-total--highlight">
          <span class="ctd-total__label">Total</span>
          <strong class="ctd-total__value">{{ (client ? totalClient : totalProvider) | number:'1.2-2' }} €</strong>
        </div>
      </div>

      <div class="ctd-empty" *ngIf="activeCount === 0">
        <mat-icon>{{ client ? 'description' : 'receipt' }}</mat-icon>
        <span class="ctd-empty__title">{{ client ? 'Sin facturas emitidas' : 'Sin gastos registrados' }}</span>
        <span class="ctd-empty__text">
          {{ client ? 'Este contacto no tiene facturas como cliente.' : 'Este contacto no tiene gastos como proveedor.' }}
        </span>
      </div>

      <div class="ctd-empty" *ngIf="activeCount > 0 && rows.length === 0">
        <mat-icon>search</mat-icon>
        <span class="ctd-empty__title">Sin resultados</span>
        <span class="ctd-empty__text">Ningún documento coincide con «{{ search }}».</span>
      </div>

      <div class="ctd-table-wrap" *ngIf="rows.length > 0">
        <table class="ctd-table">
          <thead>
            <tr>
              <th class="ctd-th--sortable" (click)="toggleSort('invoiceNumber')">
                {{ client ? 'Factura' : 'Gasto' }}
                <mat-icon class="ctd-sort" *ngIf="sortIcon('invoiceNumber')">{{ sortIcon('invoiceNumber') }}</mat-icon>
              </th>
              <th class="ctd-th--sortable" (click)="toggleSort('name')">
                {{ client ? 'Destinatario' : 'Emisor' }}
                <mat-icon class="ctd-sort" *ngIf="sortIcon('name')">{{ sortIcon('name') }}</mat-icon>
              </th>
              <th class="ctd-th--sortable" (click)="toggleSort('invoiceRelease')">
                Fecha
                <mat-icon class="ctd-sort" *ngIf="sortIcon('invoiceRelease')">{{ sortIcon('invoiceRelease') }}</mat-icon>
              </th>
              <th class="ctd-num ctd-th--sortable" (click)="toggleSort('total')">
                Total
                <mat-icon class="ctd-sort" *ngIf="sortIcon('total')">{{ sortIcon('total') }}</mat-icon>
              </th>
              <th class="ctd-num ctd-th--sortable" (click)="toggleSort('totalPaided')">
                {{ client ? 'Cobrado' : 'Pagado' }}
                <mat-icon class="ctd-sort" *ngIf="sortIcon('totalPaided')">{{ sortIcon('totalPaided') }}</mat-icon>
              </th>
              <th>Estado</th>
              <th class="ctd-actions-col">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of rows; trackBy: trackByUid">
              <td class="ctd-strong">{{ row.invoice.invoiceNumber || '—' }}</td>
              <td class="ctd-name" [title]="row.name">{{ row.name || '—' }}</td>
              <td class="ctd-nowrap">{{ row.invoice.invoiceRelease | date:'dd/MM/yyyy' }}</td>
              <td class="ctd-num">{{ (row.invoice.total || 0) | number:'1.2-2' }} €</td>
              <td class="ctd-num">{{ (row.invoice.totalPaided || 0) | number:'1.2-2' }} €</td>
              <td class="ctd-nowrap">
                <app-status-pill [label]="row.statusLabel" [variant]="row.statusVariant"></app-status-pill>
                <span class="ctd-paid-date" *ngIf="row.invoice.paided">{{ row.invoice.paided | date:'dd/MM/yyyy' }}</span>
              </td>
              <td class="ctd-actions-col">
                <div class="ctd-actions">
                  <button *ngIf="client" mat-icon-button class="ctd-action" matTooltip="Descargar PDF"
                          aria-label="Descargar PDF" (click)="pdfClient(row.invoice.uid, row.invoice.invoiceNumber)">
                    <mat-icon>description</mat-icon>
                  </button>
                  <button *ngIf="row.invoice.paided != null || !row.invoice.rectifying" mat-icon-button class="ctd-action"
                          [matTooltip]="row.invoice.paided != null
                            ? (client ? 'Cobrada el ' : 'Pagada el ') + (row.invoice.paided | date:'dd/MM/yyyy')
                            : (client ? 'Añadir cobro' : 'Añadir pago')"
                          [attr.aria-label]="client ? 'Cobro' : 'Pago'" (click)="invoicePaided(row.invoice.uid)">
                    <mat-icon>payment</mat-icon>
                  </button>
                  <button *ngIf="provider && row.invoice.image" mat-icon-button class="ctd-action" matTooltip="Descargar documento (imagen)"
                          aria-label="Descargar documento (imagen)" (click)="downloadFileImage(row.invoice.uid)">
                    <mat-icon>file_download</mat-icon>
                  </button>
                  <button *ngIf="provider && row.invoice.pdf" mat-icon-button class="ctd-action" matTooltip="Descargar documento (PDF)"
                          aria-label="Descargar documento (PDF)" (click)="downloadFilePdf(row.invoice.uid)">
                    <mat-icon>description</mat-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
    </div>
  </ng-container>
</div>
